import { RoutingDataSource } from 'src/types';
import { Fact, RoutingRule } from './RoutingRule.types';

const mapDataSourceToFriendlyName = (dataSource: Fact) => {
  if (dataSource === 'reporter') {
    return RoutingDataSource.REPORTER;
  }

  if (dataSource === 'offenders') {
    return RoutingDataSource.OFFENDER;
  }

  if (dataSource === 'report') {
    return RoutingDataSource.REPORT;
  }
};

export const readRoutingRuleDataSource = (
  rule: { all?: RoutingRule[] } | undefined | null,
) => {
  return rule?.all?.map((r) => mapDataSourceToFriendlyName(r.fact));
};
